(() => {
  if (window.__simplyPencilsLightboxLoaded) return;
  window.__simplyPencilsLightboxLoaded = true;

  const init = () => {
    document.querySelectorAll('product-modal.product-media-modal').forEach((modal) => {
      if (modal.dataset.spLightboxReady === 'true') return;
      modal.dataset.spLightboxReady = 'true';

      const dialog = modal.querySelector('.product-media-modal__dialog');
      const content = modal.querySelector('.product-media-modal__content');
      const prev = modal.querySelector('.sp-lightbox-nav--prev');
      const next = modal.querySelector('.sp-lightbox-nav--next');
      const counter = modal.querySelector('.sp-lightbox-counter');
      const thumbs = modal.querySelector('.sp-lightbox-thumbs');
      if (!dialog || !content || !prev || !next || !counter || !thumbs) return;

      
const items = () => {
  // Existing personalized pencil color selector.
  const colorSelector = document.querySelector(
    'select[id^="SP-Color-"]'
  );

  const selectedColor = (
    colorSelector?.value.match(/^(\d{2})\s*-/)?.[1] || '00'
  );

  // New pen gift set color selector.
  const penSelector = document.querySelector(
    'select[id^="sp-pen-color-"]'
  );

  const penColors = {
    'Random Color (Our Choice)': 'MIX',
    'All Five Colors': 'MIX',
    'Assorted Colors (Your Choice)': 'MIX',
    'Black': 'BLACK',
    'Blue': 'BLUE',
    'Burgundy': 'BURGUNDY',
    'Green': 'GREEN',
    'Red': 'RED'
  };

  const selectedPenColor = penColors[penSelector?.value] || 'MIX';

  const allImages = Array.from(
    content.querySelectorAll(':scope > img[data-media-id]')
  );

  // Fall back to MIX if the requested pen hero isn't available.
  const availablePenHeroes = allImages
    .map(image =>
      image.alt.toUpperCase().match(
        /SP-PEN-HERO-(MIX|BLACK|BLUE|BURGUNDY|GREEN|RED)/
      )?.[1]
    )
    .filter(Boolean);

  const activePenColor = availablePenHeroes.includes(selectedPenColor)
    ? selectedPenColor
    : availablePenHeroes.includes('MIX')
      ? 'MIX'
      : availablePenHeroes[0];

  return allImages.filter(image => {
    const alt = (image.alt || '').toUpperCase();

    // Pen hero images: include only the selected color.
    const penMatch = alt.match(
      /SP-PEN-HERO-(MIX|BLACK|BLUE|BURGUNDY|GREEN|RED)/
    );

    if (penMatch) {
      return penMatch[1] === activePenColor;
    }

    // Existing pencil variant image handling (unchanged).
    const src = image.getAttribute('src') || '';
    const match = src.match(/variant-color-(\d{2})-/i);

    if (!match) return true;

    return selectedColor !== '00' &&
           match[1] === selectedColor;
  });
};

      const activeIndex = () => {
        const list = items();
        let index = list.findIndex((item) => item.classList.contains('active'));
        if (index < 0 && list.length) {
          index = 0;
          list[0].classList.add('active');
        }
        return index;
      };

      const select = (index, focusThumb = false) => {
        const list = items();
        if (!list.length) return;

        index = (index + list.length) % list.length;
        list.forEach((item, i) => item.classList.toggle('active', i === index));

        const thumbButtons = Array.from(thumbs.querySelectorAll('.sp-lightbox-thumb'));
        thumbButtons.forEach((button, i) => {
          const active = i === index;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-current', active ? 'true' : 'false');
          if (active) {
            button.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            if (focusThumb) button.focus({ preventScroll: true });
          }
        });

        counter.textContent = (index + 1) + ' / ' + list.length;
        const hideNav = list.length <= 1;
        prev.hidden = hideNav;
        next.hidden = hideNav;
        counter.hidden = hideNav;
      };

      const buildThumbs = () => {
        const list = items();
        thumbs.innerHTML = '';

        list.forEach((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sp-lightbox-thumb';
          button.setAttribute('aria-label', 'View image ' + (index + 1));

          const img = document.createElement('img');
          img.src = item.currentSrc || item.src;
          img.alt = item.alt || '';
          img.loading = 'lazy';

          button.appendChild(img);
          button.addEventListener('pointerup', (event) => {
            event.stopPropagation();
          });
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            select(index, false);
          });
          thumbs.appendChild(button);
        });
      };

      const sync = () => {
        // The modal contents can change when a variant changes, so rebuild thumbnails on every open.
        buildThumbs();
        const index = activeIndex();
        if (index >= 0) select(index);
      };

      const go = (delta) => {
        const list = items();
        if (list.length < 2) return;
        let index = activeIndex();
        if (index < 0) index = 0;
        select(index + delta);
      };

      const keepModalOpen = (event) => {
        event.stopPropagation();
      };

      prev.addEventListener('pointerup', keepModalOpen);
      next.addEventListener('pointerup', keepModalOpen);

      prev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        go(-1);
      });

      next.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        go(1);
      });

      // Only a normal left-click on the backdrop closes the lightbox.
      // Right-click stays available for the browser's native context menu
      // (including Firefox's Take Screenshot command).
      dialog.addEventListener('pointerup', (event) => {
        if (event.button === 2) event.stopPropagation();
      });

      dialog.addEventListener('contextmenu', (event) => {
        event.stopPropagation();
      });

      dialog.addEventListener('click', (event) => {
        if (event.button === 0 && event.target === dialog) modal.hide();
      });

      modal.addEventListener('keydown', (event) => {
        if (!modal.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(1);
        }
      });

      let touchStartX = null;
      content.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX ?? null;
      }, { passive: true });

      content.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const endX = event.changedTouches[0]?.clientX ?? touchStartX;
        const distance = endX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 50) return;
        go(distance > 0 ? -1 : 1);
      }, { passive: true });

      const observer = new MutationObserver(() => {
        if (modal.hasAttribute('open')) {
          requestAnimationFrame(() => requestAnimationFrame(sync));
        }
      });
      observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => customElements.whenDefined('product-modal').then(init));
  } else {
    customElements.whenDefined('product-modal').then(init);
  }
})();
